// src/types/User.ts
import { AxiosResponse } from "axios";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";

export const TeamMembersService = {
  async addTeamMember(memberData: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/addTeamMember`,
      memberData
    );
    return res;
  },
  async getUsers(userId: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getUsers`,
      { userId: userId }
    );
    return res;
  },
  async getTeamMembers(loginEmail: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getTeamMembers`,
      { login_email: loginEmail }
    );
    return res;
  },
  async updateTeamMember(updatedData: any): Promise<AxiosResponse> {
    const res = await httpClient.put<AxiosResponse>(
      `${apiRoutePrefix}/updateTeamMember`,
      updatedData
    );
    return res;
  },
  async deleteTeamMember(userId: string): Promise<AxiosResponse> {
    return httpClient.delete<AxiosResponse>(
      `${apiRoutePrefix}/deleteTeamMember`,
      {
        data: { userId },
      }
    );
  },
  async saveUser(newUser: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/saveUser`,
      newUser
    );
    return res;
  },
  async updateUser(newUser: any): Promise<AxiosResponse> {
    const res = await httpClient.put<AxiosResponse>(
      `${apiRoutePrefix}/updateUser`,
      newUser
    );
    return res;
  },
};
